var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6728 6.72104L16.768 8.68348C17.7564 10.4545 17.3596 12.7777 15.8029 14.3344C15.8029 14.3344 13.9149 16.2227 17.3382 19.6461C20.7605 23.0684 22.65 21.1814 22.65 21.1814C24.2067 19.6247 26.5299 19.228 28.3009 20.2164L30.2633 21.3115C32.9376 22.804 33.2534 26.5543 30.9028 28.905C29.4904 30.3174 27.76 31.4165 25.8473 31.4889C22.6273 31.611 17.159 30.7961 11.6736 25.3107C6.18828 19.8254 5.37336 14.3571 5.49543 11.1371C5.56794 9.22432 6.66698 7.49401 8.07943 6.08158C10.43 3.73097 14.1803 4.04681 15.6728 6.72104Z",
    fill: "#011327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlack);
export default __webpack_public_path__ + "static/media/phoneBlack.510174eda217a80db03ca85b017626ba.svg";
export { ForwardRef as ReactComponent };